<div class="delete-modal-container">
  <div class="img-container">
    <img src="./assets/global-position/delete_account.svg" alt="">
  </div>
  <p class="main-p">¿Estas seguro que deseas eliminar la cuenta?</p>
  <p class="explain">Al eliminar tu cuenta, tus datos serán borrados y tendrás que crear una cuenta nueva para disfrutar de las ventajas de estar registrado en Akana.</p>
  <div class="btn-container">
    <button class="accept" (click)="closeModal(true)">Eliminar cuenta</button>
    <button class="cancel" (click)="closeModal(false)">Cancelar</button>
  </div>
</div>
